import { TGetContactGroupQuestionnaireResponse, TSearchScheduledOrdersBody } from '@dekafvv/sharedfrontend';
import axios from 'axios';

export const getContactGroupsById = async ({ contactGroupId }: {
    contactGroupId: string;
}) => axios.get(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.0/contactgroups/${contactGroupId}?useApplicationToken=true`,
);

export const getContactGroupQuestionnaire = async ({ contactGroupId }: {
    contactGroupId: string | number,
}) => axios.get<TGetContactGroupQuestionnaireResponse>(`${global?.AppConfig?.DSL_URL_SUFFIX}/v1/contact-groups/${contactGroupId}/questionnaire`);

export const preliminaryKeyForgotPassword = async (body: {
    email: string;
    username: string;
}) => axios.post(
    `${global?.AppConfig?.CLIENT_URL_SUFFIX}/v1.0/contacts/forgotten-password/send-preliminary-key?useApplicationToken=true`,
    body,
);

export const postSearchScheduledOrders = async ({
    contactId,
    contactGroupId,
    body,
}: {
    contactGroupId: string | number,
    contactId: string | number,
    body: TSearchScheduledOrdersBody
}) => axios.post(`${global?.AppConfig?.ROUTING_KEY_DSL}/v1.0/contact-groups/${contactGroupId}/contacts/${contactId}/orders/scheduled/search`, body);
